import { render, staticRenderFns } from "./BranchDeliveryProgressReport.vue?vue&type=template&id=21127717&"
import script from "./BranchDeliveryProgressReport.vue?vue&type=script&lang=js&"
export * from "./BranchDeliveryProgressReport.vue?vue&type=script&lang=js&"
import style0 from "./BranchDeliveryProgressReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports